export default __webpack_public_path__ + "static/media/shift4Logo.0f1c2b7f.svg";